import { render, staticRenderFns } from "./online-count-badge.vue?vue&type=template&id=77350e4e&scoped=true&"
import script from "./online-count-badge.vue?vue&type=script&lang=js&"
export * from "./online-count-badge.vue?vue&type=script&lang=js&"
import style0 from "./online-count-badge.vue?vue&type=style&index=0&id=77350e4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77350e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77350e4e')) {
      api.createRecord('77350e4e', component.options)
    } else {
      api.reload('77350e4e', component.options)
    }
    module.hot.accept("./online-count-badge.vue?vue&type=template&id=77350e4e&scoped=true&", function () {
      api.rerender('77350e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/online-count-badge.vue"
export default component.exports